import { configOne, pressCenter, foundationOne, incidentAll, recruitmentAllPage, partnerAll } from '@/api/api.js'
const getDefaultState = () => {
  return {
    config: {},
    pressnews: [],
    foundation: {},
    incidentAll: [],
    recruit: [],
    cooperation: []
  }
}
const state = getDefaultState()
const actions = {
  getConfig ({ commit }) {
    configOne().then(res => {
      commit('SET_CONFIG', res)
    })
  },
  getPressCenter ({ commit }) {
    pressCenter().then(res => {
      commit('SET_PRESSNEWS', res)
    })
  },
  getFoundationOne ({ commit }) {
    foundationOne().then(res => {
      commit('SET_FOUNDATION', res)
    })
  },
  getIncidentAll ({ commit }) {
    incidentAll().then(res => {
      commit('SET_INCIDENTALL', res)
    })
  },
  getTalentRecruitment ({ commit }) {
    recruitmentAllPage().then(res => {
      commit('SET_RECRUIT', res)
    })
  },
  getCooperation ({ commit }) {
    partnerAll().then(res => {
      commit('STE_COOPERATION', res)
    })
  }
}
const mutations = {
  SET_CONFIG (state, config) {
    state.config = config
  },
  SET_PRESSNEWS (state, pressnews) {
    state.pressnews = pressnews
  },
  SET_FOUNDATION (state, foundation) {
    state.foundation = foundation
  },
  SET_INCIDENTALL (state, incidentAll) {
    state.incidentAll = incidentAll
  },
  SET_RECRUIT (state, recruit) {
    state.recruit = recruit
  },
  STE_COOPERATION (state, cooperation) {
    state.cooperation = cooperation
  }
}
export default {
  namespaced: true,
  actions,
  mutations,
  state
}
